module.exports = __webpack_public_path__ + "static/media/fary_edited.cec17a9f.jpg";